import { PlaylistAnimationEnum } from '@modules/digital-signage/model/playlists.model.ts';

export interface AnimationPreviewPopoverProps {
  anchorEl: HTMLElement | null;
  animation: PlaylistAnimationEnum;
  previewSrc?: string;
  onClose: () => void;
}

export const ANIMATION_LABELS: Record<PlaylistAnimationEnum, string> = {
  [PlaylistAnimationEnum.None]: 'No Animation',
  [PlaylistAnimationEnum.Fade]: 'Fade'
};
